
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shorthand]",
      function () {
        return require("private-next-pages/[shorthand]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shorthand]"])
      });
    }
  